import React from "react";
import "./ProductDetails.css"; // Ümumi CSS

const AquariumFishDetails = ({ product }) => {
    if (!product) return <p>Məhsul detalları yüklənmir...</p>;

    const getStatus = (val) =>
        val === true ? "Bəli" : val === false ? "Xeyr" : "Bilinmir";

    return (
        <div className="product-details">
            <h3 className="product-details-title">Akvaryum Balığı Məlumatları</h3>
            <div className="product-details-grid">
                <div className="product-details-column">
                    <div className="product-details-item"><strong>Şəhər:</strong> {product.city || "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Balıq növü:</strong> {product.fishType || "Məlumat yoxdur"}</div>
                    <div className="product-details-item"><strong>Yaş:</strong> {product.age ? `${product.age} ay` : "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Cinsiyyət:</strong> {product.gender || "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Ölçü:</strong> {product.size ? `${product.size} cm` : "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Rəng:</strong> {product.color || "Bilinmir"}</div>
                </div>

                <div className="product-details-column">
                    <div className="product-details-item"><strong>Sağlamlıq durumu:</strong> {product.healthStatus || "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Akvarium daxildirmi?:</strong> {getStatus(product.includesAquarium)}</div>
                    {product.aquariumVolume && (
                        <div className="product-details-item"><strong>Akvarium həcmi:</strong> {product.aquariumVolume} litr</div>
                    )}
                    {product.accessories?.length > 0 && (
                        <div className="product-details-item">
                            <strong>Aksesuarlar:</strong> {product.accessories.join(", ")}
                        </div>
                    )}
                </div>
            </div>

            {product.description && (
                <div className="product-description">
                    <strong>Açıqlama:</strong>
                    <p>{product.description}</p>
                </div>
            )}
        </div>
    );
};

export default AquariumFishDetails;
